import { css } from 'styled-components'

// This object sets the breakpoints for styled-system components
// We rely on wraparound behaviour so adding or removing breakpoints will unexpectedly change the layout
export const breakpoints = {
  smallPhone: 0,
  phone: 500,
  tablet: 768,
  desktop: 1080,
}

const mq = Object.keys(breakpoints).reduce((accumulator, breakpoint) => {
  const emSize = breakpoints[breakpoint] / 16
  accumulator[breakpoint] = (...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)};
    }
  `
  return accumulator
}, {})

export default mq
